import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { Button, Modal, Grid, Row, Col, FormGroup, ControlLabel, Collapse, Alert } from 'react-bootstrap';
import { animateScroll, scroller } from 'react-scroll';
import { isEmpty, isEqual } from 'lodash/lang';
import { each, every, filter, includes, map } from 'lodash/collection';
import { get, keys } from 'lodash/object';
import { last } from 'lodash/array';
import { range } from 'lodash/util';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
// import { SingleDatePicker } from 'react-dates';
// import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { translate, Interpolate } from 'react-i18next';
import _ from 'lodash';
import UnitInfo from '../UnitInfo/';
import TimeSlotCard from '../../components/TimeSlotCard/';
import './Booking.scss';

import AdditionalDiscussionCheckbox from '../../components/AdditionalDiscussionCheckbox/';
import BookingPhase from '../../components/BookingPhase/';
import SymptomLevel from '../../components/SymptomLevel/';
import CodeForm from '../../components/CodeForm/';
import SimpleBox from '../../components/SimpleBox/';
import RegistrationForm from '../RegistrationForm/';
import InfoBox from '../../components/InfoBox/';
import OptionGroup from '../../components/OptionGroup/';
import SingleSelectButton from '../../components/SingleSelectButton/';
import MultiSelectButton from '../MultiSelectButton/';
import ErrorMessage from '../../components/Messages/ErrorMessage';
import TimeSlots from '../TimeSlots/';
import SelectionPathInfo from '../../components/SelectionPathInfo/';
import ConfirmTimeSlotForm from '../../components/ConfirmTimeSlotForm/';
import AppIcon from '../../components/AppIcon';
import UnitInfoContainer from './UnitInfoContainer';
import { scrollSettings, DATE_FORMAT_SYSTEM, EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION, letUserModifyTimeSlotParams,
  showAdditionalDiscussionCheckbox, DEFAULT_START_TIME } from './../../util/constants';
import { htmlDecode, trimResourceNames, isElementVisible } from './../../util/helpers';
import i18n from '../../i18n';
import unitHelper from '../../util/unitHelper';
import pathTypes from '../../enums/pathTypes';
import ByTicket from '../ByTicket/';
import History from '../History/';
import InnerHtmlContent from '../../components/InnerHtmlContent';
import api from '../../api';
import LoginFormSelector from './LoginFormSelector';
import LoginComponent from './LoginComponent';

const timeMomentSort = (a, b) => (a.timeMoment.isBefore(b.timeMoment) ? -1 : 1);

class Booking extends Component {

  /*
  Bind needed methods to the instance of component, define default values and state
   */
  constructor(props) {
    super(props);
    this.onCloseErrorModal = this.onCloseErrorModal.bind(this);
    this.toggleUseCode = this.toggleUseCode.bind(this);
    this.requestTimeSlotsUsingCode = this.requestTimeSlotsUsingCode.bind(this);
    this.requestTimeSlotsHandler = this.requestTimeSlotsHandler.bind(this);
    this.additionalDiscussionValueChanged = this.additionalDiscussionValueChanged.bind(this);
    this.select = this.select.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.activateModifyTimeSlotParams = this.activateModifyTimeSlotParams.bind(this);
    this.modifyTimeSlotParams = this.modifyTimeSlotParams.bind(this);
    this.updateFilters = this.updateFilters.bind(this);
    this.updateStartTimeFilter = this.updateStartTimeFilter.bind(this);
    this.useFilters = this.useFilters.bind(this);
    this.selectTimeSlot = this.selectTimeSlot.bind(this);
    this.confirmTimeSlot = this.confirmTimeSlot.bind(this);
    this.resetBookingState = this.resetBookingState.bind(this);
    this.cancelConfirm = this.cancelConfirm.bind(this);
    this.getSelection = this.getSelection.bind(this);
    this.emailConfirmationEnabled = this.emailConfirmationEnabled;
    this.smsConfirmationEnabled = this.smsConfirmationEnabled;
    this.onDateChange = this.onDateChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.initialState = {
      useCode: false,
      modifyTimeSlotParamsActivated: false,
      modifiedTimeSlotParams: {},
      userClickedRequestTimeSlots: false,
      date: moment(),
      filters: {
        unit: [],
        resource: []
      },
      isMobile: window.innerWidth < 768,
      startTimeFilter: DEFAULT_START_TIME,
      filteredTimeSlotsByDate: {},
      showMobileDatePicker: false,
      selectedTimeSlot: {},
      reset: false,
      targetLevel: 1,
      dedicatedResources: {},
      ownCareTeamSelected: false,
      showingTimesForCareTeam: false
    };

    this.state = this.initialState;

    const { selectedStoredTimeSlot, restoredState } = props;
    let processedSelectedStoredTimeslot;
    if (Object.keys(selectedStoredTimeSlot).indexOf('timeMoment') !== -1) {
      processedSelectedStoredTimeslot = {
        ...selectedStoredTimeSlot,
        timeMoment: moment(selectedStoredTimeSlot.timeMoment)
      };
    }

    this.filtersConfig = {
      unit: {
        label: 'Toimipiste',
        items: this.props.units
      },
      resource: {
        label: 'Asiantuntija',
        items: {}
      }
    };
    this.startTimeItems = range(24).map(hour => ({
      id: hour,
      name: moment({ hour, minute: 0 }).format('LT')
    }));
    if (processedSelectedStoredTimeslot && Object.keys(processedSelectedStoredTimeslot).length !== 0 && restoredState) {
      this.state = {
        ...this.initialState,
        date: processedSelectedStoredTimeslot.timeMoment,
        selectedTimeSlot: processedSelectedStoredTimeslot
      };
      this.props.unsetSelectedTimeslotToStore();
    }
  }

  componentDidMount() {
    const { restoredState, timeSlots, requiresEmployer } = this.props;
    window.addEventListener('resize', this.handleResize);
    if (restoredState && !requiresEmployer) {
      this.useFilters(timeSlots, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    const userJustLoggedOut = (this.props.userIdentified && !nextProps.userIdentified);
    // if user just logged out reset the state of booking and scroll to top of the page
    if (userJustLoggedOut) {
      console.log('userJustLoggedOut -> Booking.initialState');
      this.setState(this.initialState, () => {
        animateScroll.scrollToTop(scrollSettings);
      });
      this.toggleUseCode(this.initialState.useCode);
      // user has requested timeslots or changed filters set up
    } else if (!isEmpty(nextProps.timeSlots) && nextProps.timeSlots !== this.props.timeSlots) {
      const state = {};
      // udpate units and resources if changed
      if (nextProps.units !== this.props.units) {
        console.log('Updating unit filter config!');
        state.filtersConfig.unit.items = this.props.units;
      }
      if (nextProps.resources !== this.props.resources) {
        console.log('Updating resource filter config!');
        state.filtersConfig.resource.items = this.props.resources;
      }
      // if user requested timeslots, process filters to further apply to timeslots
      this.setState(state, () => {
        if (this.state.userClickedRequestTimeSlots) {
          this.initializeFilters();
        }
        this.useFilters(nextProps.timeSlots);
      });
    }
    const selectionHandler = this.props.selectionHandler;
    const byTicket = nextProps.selectedPathType === pathTypes.BY_TICKET;
    // set path type in selectoin handler according to used path type
    if (byTicket) {
      selectionHandler.setIsByTicket();
    } else {
      selectionHandler.removeByTicket();
    }
    // NOTE: here we react when the selected ticket has changed
    if (byTicket && nextProps.hasSelectedTicket && !_.isEqual(this.props.selectedTicket, nextProps.selectedTicket)) {
      // set the handler to the new ticket
      selectionHandler.setTicket(nextProps.selectedTicket);
      // de-select the time slot and reset dedicated resources
      this.setState({
        selectedTimeSlot: {},
        dedicatedResources: {}
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // if user is requesting timeslots and he has selected employer department, request timeslots
    // once again with home unit filter
    if (this.state.userClickedRequestTimeSlots) {
      const userJustSelectedEmployerDepartment = (
        (prevProps.selectedEmployer !== this.props.selectedEmployer) &&
        (this.props.selectedEmployer >= 0)
      );
      if (userJustSelectedEmployerDepartment) {
        const timeSlotParams = this.getCurrentTimeSlotParams();
        const { user } = this.props;
        if (user && user.homeUnitId) {
          timeSlotParams.homeUnitId = user.homeUnitId;
        }
        this.props.requestTimeSlots(timeSlotParams);
        return;
      }
    }
    const selectionHandler = this.props.selectionHandler;
    const selectedOptionIds = selectionHandler.getSelectedOptionIds();
    const selectedLevels = selectedOptionIds.length;
    const finalLevelReached = selectionHandler.isFinalLevelReached();
    const finalOption = selectionHandler.getLastSelectedOption();
    const targetLevel = this.state.targetLevel;

    let scrollElement;
    // indentify where to scroll (if needed) after component update
    const extraSettings = {};
    if (prevState.showMobileDatePicker !== this.state.showMobileDatePicker) {
      // Don't scroll if showMobileDatePicker changed.
    } else if (this.props.requestingTimeSlots) {
      // Don't scroll while loading time slots.
    } else if (this.props.currentlyIdentifying) {
      // Don't scroll while identifying.
    } else if (this.props.currentlyRegistering) {
      // Don't scroll while registering.
    } else if (this.props.storingReservation) {
      // Don't scroll while storing the reservation.
    } else if (this.props.reservationDone) {
      scrollElement = 'booking-phase-reservation-done';
    } else if (!isEqual(prevState.modifiedTimeSlotParams, this.state.modifiedTimeSlotParams)) {
      // Don't scroll if modifiedTimeSlotParams changed.
    } else if (!isEmpty(this.state.selectedTimeSlot)) {
      scrollElement = 'booking-phase-confirm-container';
    } else if (this.state.userClickedRequestTimeSlots || !isEmpty(this.props.timeSlots)) {
      scrollElement = 'booking-phase-select-time-container';
    } else if (finalLevelReached && (finalOption.reservation || finalOption.external)) {
      scrollElement = null;
      const element = '#anchor-scroll-target';
      if (isElementVisible(element)) {
        return;
      }
      const target = $(element).offset().top - ($(window).height() - $(element).height());
      animateScroll.scrollTo(target + 10, { ...scrollSettings, ...extraSettings });
    } else if (selectedLevels) {
      scrollElement = `booking-phase-symptoms-${targetLevel + 1}`;
    }
    // if scroll element was defined, scroll there
    if (scrollElement) {
      console.log(`scrolling to: ${scrollElement}`);
      scroller.scrollTo(scrollElement, { ...scrollSettings, ...extraSettings });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // after closing error message, reload the page
  onCloseErrorModal() {
    window.location.reload();
  }


  onDateChange(date) {
    const momentDate = moment(date);
    this.setState({ date: momentDate });
  }

  getCurrentTimeSlotParams() {
    let timeSlotParams = {};
    const selectionHandler = this.props.selectionHandler;
    if (selectionHandler.isUsingPath()) {
      const finalLevelReached = selectionHandler.isFinalLevelReached();
      if (finalLevelReached) {
        const finalOption = selectionHandler.getLastSelectedOption();
        if (finalOption.reservation) {
          timeSlotParams = Object.assign({}, finalOption.reservation);
          // add additional discussion needed time to timeslot duration
          if (this.props.additionalDiscussionChecked) {
            if (typeof timeSlotParams.duration === 'object') {
              // if timeslot duration has defined type
              Object.keys(timeSlotParams.duration)
                .forEach((type) => {
                  timeSlotParams.duration[type] += EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION;
                });
            } else {
              // if timeslot duration is a number
              timeSlotParams.duration += EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION;
            }
          }
        }
      }
    } else if (selectionHandler.isUsingCode()) {
      //  we need to map the groups' name to groups' codes to find if there is a special group for timeslots provided with a code
      const { groups } = this.props;
      const code = selectionHandler.getCode();
      const regex = new RegExp(`^VARAUS-KOODILLA:${code}$`);
      const codeGroup = Object.keys(groups).filter(key => groups[key].name.match(regex));
      const codeGroupParam = codeGroup.length ? codeGroup[0] : null;
      const resources = { timeType: code };
      if (codeGroupParam) {
        resources.inGroups = [codeGroupParam];
      }
      timeSlotParams = {
        resources: [resources]
      };
    } else if (selectionHandler.isByTicket()) {
      console.log('reservation by ticket');
    }
    const { utilizeEmployerInformation } = this.props;
    timeSlotParams.responsibleResources = [];

    // add employer infromation and responsible resources to timeslot params if needed
    if (utilizeEmployerInformation) {
      const userEmployer = this.getUserEmployer();
      if (userEmployer) {
        timeSlotParams.company = userEmployer.company;
        timeSlotParams.responsibleResources = this.getResponsibleResources();
      }
    }
    // change duration and specialty in case those parameters were changed in new timeslot params
    if (this.state.modifiedTimeSlotParams) {
      if (this.state.modifiedTimeSlotParams.duration) {
        timeSlotParams.duration = this.state.modifiedTimeSlotParams.duration;
      }
      if (this.state.modifiedTimeSlotParams.speciality) {
        timeSlotParams.resources[0].speciality = this.state.modifiedTimeSlotParams.speciality;
      }
    }
    timeSlotParams.userIdentified = this.props.userIdentified;
    timeSlotParams.legalEntity = this.props.legalEntity;
    timeSlotParams.canAnonymousFetchTimes = this.props.canAnonymousFetchTimes;
    return timeSlotParams;
  }

  getUserEmployer() {
    let userEmployer = {};
    const user = this.props.user;
    if (user.employers && user.employers.length) {
      userEmployer = user.employers[this.props.selectedEmployer] || {};
    }
    return userEmployer;
  }


  // get all responsible resourses from user's employer
  getResponsibleResources() {
    // if ticket has dedicated resources, use those instead of user employer.
    if (this.state.dedicatedResources && this.state.dedicatedResources.resources) {
      const resources = [];
      const timeSlotDefinitions = this.props.selectionHandler.ticket.timeSlotDefinitions[0];
      if (timeSlotDefinitions && timeSlotDefinitions.inGroups) {
        const isDedicatedResources = _.find(timeSlotDefinitions.inGroups, 'dedicated');
        if (isDedicatedResources !== -1) {
          Object.entries(this.state.dedicatedResources.resources).forEach(
            ([key, value]) => {
              resources.push({ 'resource': key, 'name': value });
            }
            );
          return trimResourceNames(resources);
        }
      }
    }
    let responsibleResources = [];
    const userEmployer = this.getUserEmployer();
    if (this.props.hasDepartment) {
      const departments = userEmployer.departments || [];
      const userDepartment = departments[this.props.selectedDepartment];
      if (userDepartment && userDepartment.resources && userDepartment.resources.length) {
        responsibleResources = userDepartment.resources;
      }
    } else {
      responsibleResources = userEmployer.resources || [];
    }
    return trimResourceNames(responsibleResources);
  }


  // get responsible resources based on selected speciality
  getCurrentResponsibleResources() {
    let currentResponsibleResources = [];
    const selectionHandler = this.props.selectionHandler;
    if (selectionHandler.isUsingPath()) {
      const timeSlotParams = this.getCurrentTimeSlotParams();
      const requestedSpeciality = get(timeSlotParams, 'resources[0].speciality');
      currentResponsibleResources = this.getResponsibleResources().filter((r) => {
        if (Array.isArray(requestedSpeciality)) {
          return requestedSpeciality.indexOf(r.speciality) > -1;
        }
        return requestedSpeciality === r.speciality;
      });
    }
    console.log('getCurrentResponsibleResources', currentResponsibleResources);
    return currentResponsibleResources;
  }

  getTimeSlotsForSelectedDay() {
    const formattedDay = this.state.date.format(DATE_FORMAT_SYSTEM);
    return this.state.filteredTimeSlotsByDate[formattedDay]
    ? this.state.filteredTimeSlotsByDate[formattedDay]
    : [];
  }

  getSelectedFilters(filterId) {
    return this.state.filters[filterId] || [];
  }

  getUnitData(unitId) {
    return this.props.units[unitId];
  }


  // get last selected option in path
  getSelection() {
    const selectedPath = this.props.selectionHandler.getSelectedOptions();
    if (selectedPath && selectedPath.length) {
      return selectedPath[selectedPath.length - 1];
    }
    return null;
  }


  // build a sentence for requesting time slots section labeol
  getSentenceForTimeSlotParams(modifyTimeSlotParamsActivated) {
    const { pathNamespace, selectionHandler, t } = this.props;
    const selectedPath = selectionHandler.getSelectedOptions();
    const selectedLastLevel = selectedPath.length > 0 ? selectedPath[selectedPath.length - 1] : null;
    let specialityTextKey = null;
    if (selectedLastLevel && selectedLastLevel.reservation && selectedLastLevel.reservation.specialityTextKey) {
      specialityTextKey = selectedLastLevel.reservation.specialityTextKey;
    }
    let sentence;
    const durationUnit = t('duration_unit');
    const getDurationLabel = d => (isNaN(d) ? '' : `${d} ${durationUnit}`);
    const getSpecialityLabel = s => t(`${pathNamespace}:for_specialist_${s}`, { defaultValue: '' });
    const timeSlotParams = this.getCurrentTimeSlotParams();
    const { speciality } = timeSlotParams.resources[0];

    // if duration or speciality can be modified
    if (modifyTimeSlotParamsActivated) {
      const durationFilterId = 'duration';
      const specialityFilterId = 'speciality';
      let durationFilterItems = [];
      let specialityFilterItems = [];
      if (timeSlotParams.options) {
        // Use only items that are defined in config for current path.
        if (timeSlotParams.options.duration) {
          durationFilterItems = timeSlotParams.options.duration.map(
            d => ({ id: d, name: getDurationLabel(d) })
          );
        }
      } else {
        durationFilterItems = [
          { id: 5, name: getDurationLabel(5) },
          { id: 10, name: getDurationLabel(10) },
          { id: 15, name: getDurationLabel(15) },
          { id: 20, name: getDurationLabel(20) },
          { id: 30, name: getDurationLabel(30) },
          { id: 45, name: getDurationLabel(45) },
          { id: 60, name: getDurationLabel(60) },
          { id: 70, name: getDurationLabel(70) },
          { id: 75, name: getDurationLabel(75) }
        ];
        specialityFilterItems = [
          { id: '/specialities/2', name: getSpecialityLabel('/specialities/2') },
          { id: '/specialities/14', name: getSpecialityLabel('/specialities/14') },
          { id: '/specialities/20', name: getSpecialityLabel('/specialities/20') },
          { id: '/specialities/27', name: getSpecialityLabel('/specialities/27') }
        ];
      }
      const sentenceParams = {
        resourceType: t(`for_resourceType_${timeSlotParams.resources[0].type}`, { defaultValue: '' }),
        time: t(`time_type_${timeSlotParams.resources[0].timeType}`.replace('.', '*'), { defaultValue: t('time_type_default') })
      };
      if (!isEmpty(durationFilterItems)) {
        sentenceParams.duration = (
          <SingleSelectButton
            id={durationFilterId}
            items={durationFilterItems}
            activeItem={timeSlotParams.duration}
            onSelect={this.modifyTimeSlotParams}
            disabled={this.state.userClickedRequestTimeSlots}
          />
        );
      } else {
        sentenceParams.duration = getDurationLabel(timeSlotParams.duration);
      }
      if (!isEmpty(specialityFilterItems)) {
        sentenceParams.specialist = (
          <SingleSelectButton
            id={specialityFilterId}
            items={specialityFilterItems}
            activeItem={Array.isArray(speciality) ? speciality[0] : speciality}
            onSelect={this.modifyTimeSlotParams}
            disabled={this.state.userClickedRequestTimeSlots}
          />
        );
        sentenceParams.time += ' ';
      } else {
        sentenceParams.specialist = specialityTextKey ? t(`${pathNamespace}:specialtyTexts.${specialityTextKey}`) : getSpecialityLabel(Array.isArray(speciality) ? speciality[0] : speciality);
      }
      sentence = (
        <Interpolate
          i18nKey="request_time_slots_info"
          {...sentenceParams}
        />
      );
    } else { // if there is no modification for speciality or duration of timeslot
      const sentenceParams = {
        duration: getDurationLabel(timeSlotParams.duration),
        resourceType: t(`for_resourceType_${timeSlotParams.resources[0].type}`, { defaultValue: '' }),
        specialist: specialityTextKey ? t(`${pathNamespace}:specialtyTexts.${specialityTextKey}`) : getSpecialityLabel(Array.isArray(speciality) ? speciality[0] : speciality),
        time: t(`time_type_${timeSlotParams.resources[0].timeType}`.replace('.', '*'), { defaultValue: t('time_type_default') })
      };
      sentence = t('request_time_slots_info', sentenceParams);
    }
    return sentence;
  }


  // get login component depending on authentication policy
  getLoginForm(t) {
    const { loginPolicyType } = this.props;

    return (
      <LoginFormSelector loginPolicyType={loginPolicyType} t={t} />
    );
  }

  isUserSotuTemporary() {
    return this.props.user.sotu.substring(7, 8) === '9';
  }

  handleResize() {
    this.setState({ isMobile: window.innerWidth < 768 });
  }

  populateResourceFilter(resources) {
    this.setState({ showingTimesForCareTeam: !this.state.showingTimesForCareTeam });
    let items = map(resources, r => r.resource);
    const itemKeys = keys(this.filtersConfig.resource.items);
    items = filter(items, item => includes(itemKeys, item));
    this.updateFilters('resource', items);
  }

  applyDefaultFilter(resources) {
    this.setState({ ownCareTeamSelected: true, showingTimesForCareTeam: true });
    this.populateResourceFilter(resources);
  }

  filterByDuration(duration, timeSlots) {
    const filteredTimeSlots = [];
    const now = moment();
    const { pathNamespace, units, resources, t } = this.props;
    // console.log('units', units);
    timeSlots.forEach((timeSlot) => {
      const consequtiveSlotsRequired = duration ? (duration / timeSlot.duration) - 1 : 0;
      const { speciality } = timeSlot;
      const resourceType = t(`resources.time_type_${timeSlot.type.replace('.', '*')}`,
        { defaultValue: t(`${pathNamespace}:resources.${Array.isArray(speciality) ? speciality[0] : speciality}`, { defaultValue: '' }) });
      timeSlot.times.forEach((item, index, array) => {
        // check that the time is immediately after this one.
        // Check that there are enough many times to cover the whole duration
        // Add starting time to times.
        const timeMoment = moment(item);
        if (timeMoment.isBefore(now)) {
          // A time in the past
          return;
        }
        if (consequtiveSlotsRequired) {
          if (consequtiveSlotsRequired < 1) {
            // the time slot is longer than what we require, let's not try to book a part of it
            return;
          }
          if (index + consequtiveSlotsRequired >= array.length) {
            // Not enough consequtive times in the array after this one
            // (No need to parse times beyond this, would be more efficient to break a for loop...)
            return;
          }
          if (-timeMoment.diff(array[index + consequtiveSlotsRequired], 'minutes') !== (timeSlot.duration * consequtiveSlotsRequired)) {
            // Not enough times next to each other
            return;
          }
        }
        const timeSlotUnitExists = Object.prototype.hasOwnProperty.call(units, timeSlot.unit);
        const timeSlotResourceExists = Object.prototype.hasOwnProperty.call(resources, timeSlot.resource);
        // there is enough time
        if (timeSlotUnitExists && timeSlotResourceExists) {
          filteredTimeSlots.push({
            ...timeSlot,
            timeMoment,
            duration,
            unitName: units[timeSlot.unit].name,
            unitAddress: units[timeSlot.unit].address,
            resourceName: resources[timeSlot.resource].name,
            resourceType
          });
        } else {
          // Correct time slot exists, BUT timeslot unit OR resource does not exist any more
          console.log('ERROR: Timeslot resource OR unit did not exist:');
          console.log('Units:', this.props.units);
          console.log('Resources:', this.props.resources);
          console.log('timeSlot:', timeSlot);
        }
      });
    });
    console.log('Filtered time slots by duration', timeSlots, duration, filteredTimeSlots);
    return filteredTimeSlots;
  }

  filterForReservationByCode(timeSlots) {
    const filteredTimeSlots = [];
    const now = moment();
    const { pathNamespace } = this.props;
    timeSlots.forEach((timeSlot) => {
      const { speciality } = timeSlot;
      const resourceType = this.props.t(`resources.time_type_${timeSlot.type.replace('.', '*')}`,
        { defaultValue: this.props.t(`${pathNamespace}:resources.${Array.isArray(speciality) ? speciality[0] : speciality}`, { defaultValue: '' }) });
      timeSlot.times.forEach((item) => {
        const timeMoment = moment(item);
        if (timeMoment.isBefore(now)) {
          // A time in the past
          return;
        }
        filteredTimeSlots.push({
          ...timeSlot,
          timeMoment,
          unitName: this.props.units[timeSlot.unit].name,
          unitAddress: this.props.units[timeSlot.unit].address,
          resourceName: this.props.resources[timeSlot.resource].name,
          resourceType
        });
      });
    });
    console.log('Filtered time slots for reservations by code', timeSlots, filteredTimeSlots);
    return filteredTimeSlots;
  }

  // return timeslots after a selected hour in a day in filters
  filterByStartTime(startTimeHour, timeSlots) {
    if (timeSlots.length) {
      return filter(timeSlots, (timeSlot) => {
        const startTimeMoment = timeSlot.timeMoment.clone().hour(startTimeHour).minute(0);
        return timeSlot.timeMoment.isSameOrAfter(startTimeMoment);
      });
    }
    return timeSlots;
  }

  hasFreeTimesForDay(day) {
    const dateObj = moment(day ? new Date(day) : {});
    const formattedDay = dateObj.format(DATE_FORMAT_SYSTEM);
    const timeSlots = this.state.filteredTimeSlotsByDate[formattedDay];
    return !!(timeSlots && timeSlots.length);
  }

  // set path or code based booking type in selectoin handler with reset of the state
  toggleUseCode(useCode) {
    const selectionHandler = this.props.selectionHandler;
    if (useCode) {
      selectionHandler.useCode();
    } else {
      selectionHandler.usePath();
    }
    this.setState({
      useCode,
      modifyTimeSlotParamsActivated: false,
      modifiedTimeSlotParams: this.initialState.modifiedTimeSlotParams,
      userClickedRequestTimeSlots: false,
      filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
      selectedTimeSlot: this.initialState.selectedTimeSlot
    });
    this.props.selectedOptionsChanged([]);
  }

  requestTimeSlotsUsingCode(code) {
    const selectionHandler = this.props.selectionHandler;
    selectionHandler.setCode(code);
    this.requestTimeSlotsHandler();
  }

  requestTimeSlotsHandler(params) {
    const timeSlotParams = this.getCurrentTimeSlotParams();
    let date;
    if (params && params.month) {
      console.log('setting calendar', params, this.state.date);
      date = params.month;
      timeSlotParams.from = date.clone().startOf('month');
      timeSlotParams.to = date.clone().endOf('month');
    } else {
      // Reset calendar view to current month
      date = moment();
    }
    const dateString = new Date(date);
    this.setState({
      userClickedRequestTimeSlots: true,
      filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
      selectedTimeSlot: this.initialState.selectedTimeSlot,
      date,
    });
    if (this.props.userIdentified || this.props.canAnonymousFetchTimes) {
      const { user } = this.props;
      if (user && user.homeUnitId) {
        timeSlotParams.homeUnitId = user.homeUnitId;
      }
      const selectionHandler = this.props.selectionHandler;
      if (selectionHandler.isByTicket() && selectionHandler.ticket &&
      selectionHandler.ticket.isMovendosTimeReservationTicket &&
        selectionHandler.ticket.orgIdForDedicated) {
        timeSlotParams.company = selectionHandler.ticket.orgIdForDedicated;
        timeSlotParams.orgIdForDedicated = selectionHandler.ticket.orgIdForDedicated;

        api.requestDedicatedResources(selectionHandler.ticket.orgIdForDedicated).then((resources) => {
          timeSlotParams.responsibleResources = resources;
          // store dedicated resources for filters
          this.state.dedicatedResources = resources;
          this.props.requestTimeSlots(timeSlotParams);
        });
      } else {
        this.props.requestTimeSlots(timeSlotParams);
      }
    }
  }

  // change the value of need in additional discussion and reset the state as needed time changes
  additionalDiscussionValueChanged(event) {
    this.setState({
      userClickedRequestTimeSlots: false,
      filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
      selectedTimeSlot: this.initialState.selectedTimeSlot
    });
    this.props.additionalDiscussionChanged(event.target.checked);
  }


  // select path option and reset app state to options selection
  select(selectionId) {
    const selectionHandler = this.props.selectionHandler;
    if (selectionHandler.select(selectionId)) {
      this.setState({
        modifyTimeSlotParamsActivated: false,
        modifiedTimeSlotParams: this.initialState.modifiedTimeSlotParams,
        userClickedRequestTimeSlots: false,
        filters: this.initialState.filters,
        filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
        selectedTimeSlot: this.initialState.selectedTimeSlot,
        ownCareTeamSelected: false,
        showingTimesForCareTeam: false
      });

      this.props.selectedOptionsChanged(selectionHandler.getSelectedOptionIds());
    }
  }


  // allow user modifying timeslot params and drop selected timeslot
  activateModifyTimeSlotParams() {
    this.setState({
      modifyTimeSlotParamsActivated: true,
      userClickedRequestTimeSlots: false,
      filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
      selectedTimeSlot: this.initialState.selectedTimeSlot,
      ownCareTeamSelected: false,
      showingTimesForCareTeam: false
    });
    this.props.clearTimeSlots();
  }

  // modify timeslot param by given filter key and a new value for a filter
  modifyTimeSlotParams(filterId, itemId) {
    this.setState({
      modifiedTimeSlotParams: {
        ...this.state.modifiedTimeSlotParams,
        [filterId]: itemId
      }
    });
  }

  selectDate(date) {
    const momentDate = moment(date);
    this.setState({
      date: momentDate,
      selectedTimeSlot: this.initialState.selectedTimeSlot,
      showMobileDatePicker: false,
    });
  }

  initializeFilters() {
    const params = this.getCurrentTimeSlotParams().resources[0];
    const units = this.props.units;
    const groups = this.props.groups || [];
    const resources = this.props.resources;
    const resourceItems = {};
    const dedicated = {};
    let dedicatedUnits;
    this.getResponsibleResources().forEach((resource) => {
      dedicated[resource.resource] = resource.name;
    });
    const isInGroup = (resource, group) => {
      if (group === 'dedicated') {
        if (dedicated[resource.resource]) {
          return true;
        }
      } else if (groups && groups[group] && groups[group][resource.resource]) {
        // in this if we must make sure that all the attributes are not undefined
        return true;
      }
      return false;
    };
    /**
     * This is a pile of crap made by Vincit.
     * It iterates through all of the resources which are a JSON.
     * So they iterate them by the keys and then if the given resource
     * matches the criteria defined in the params then it is added.
     * The if statements here are checking if the param is defined or not.
     * If it is not then do not use it to exclude the resource.
     */
    Object.keys(resources).forEach((key) => {
      const resource = resources[key];
      if (!resource || !resource.resource) {
        return;
      }
      if (params.type && resource.type !== params.type) {
        return;
      }
      // if speciality is an array then check if the resource.speciality is NOT contained in the params.speciality array
      if (params.speciality && Array.isArray(params.speciality) && params.speciality.indexOf(resource.speciality) === -1) {
        return;
      }
      // if speciality is not an array then it is a string and we should just compare it to resource.speciality
      if (params.speciality && !Array.isArray(params.speciality) && resource.speciality !== params.speciality) {
        return;
      }
      if (params.inGroups && !params.inGroups.some(group => isInGroup(resource, group))) {
        return;
      }
      if (params.notInGroups && params.notInGroups.some(group => isInGroup(resource, group))) {
        return;
      }
      // The inResources parameter is usually there but the length is zero if there are no resources to search for.
      if (params.inResources && params.inResources.length > 0 && params.inResources.indexOf(resource.resource) === -1) {
        return;
      }
      resourceItems[resource.resource] = resource;
    });

    if (this.state.dedicatedResources && this.state.dedicatedResources.units) {
      dedicatedUnits = this.state.dedicatedResources.units;
    }
    this.filtersConfig.resource.items = resourceItems;
    this.filtersConfig.unit.items = unitHelper.unitFiltering(params, this.props.user, units, this.props.canAnonymousFetchTimes, this.props.legalEntity, dedicatedUnits);

    if (this.props.utilizeEmployerInformation && this.props.showOwnTeamByDefault && !this.state.ownCareTeamSelected) {
      const responsibleSpecialists = this.getCurrentResponsibleResources();
      this.applyDefaultFilter(responsibleSpecialists);
    }
  }

  updateFilters(filterId, items) {
    console.log('Updating filters', filterId, items);
    const filters = {
      ...this.state.filters,
      [filterId]: items
    };

    this.setState({
      filters,
      selectedTimeSlot: this.initialState.selectedTimeSlot
    }, this.useFilters);
  }

  updateStartTimeFilter(filterId, startTimeFilter) {
    this.setState({
      startTimeFilter
    }, () => {
      this.useFilters(null, false);
    });
  }


  // apply all needed filters defined above
  useFilters(initialTimeSlots, selectFirstDayWithTimes = true) {
    let timeSlotsByDate;
    let firstDayWithTimes;
    // timeslots can be supplied from the next coming props to component
    if (initialTimeSlots) {
      console.log('*** useFilters: initialTimeSlots ***', initialTimeSlots);
      timeSlotsByDate = initialTimeSlots;
    } else {
      console.log('*** useFilters: props.timeSlots ***', this.props.timeSlots);
      timeSlotsByDate = this.props.timeSlots;
    }

    const filteredTimeSlotsByDate = {};
    const duration = this.getCurrentTimeSlotParams().duration;
    const today = moment();

    each(timeSlotsByDate, (timeSlots, date) => {
      let filteredTimeSlots;
      if (this.state.useCode) {
        filteredTimeSlots = this.filterForReservationByCode(timeSlots);
      } else {
        filteredTimeSlots = this.filterByDuration(duration, timeSlots);
      }
      filteredTimeSlots = this.filterByStartTime(this.state.startTimeFilter, filteredTimeSlots);
      console.log('Using filters', this.state.filters, timeSlots, filteredTimeSlots);

      filteredTimeSlotsByDate[date] = filteredTimeSlots.filter((timeSlot) => {
        const allFiltersPassed = every(this.state.filters, (filterItems, filterId) => {
          // For every selected filter
          if (filterItems.length && !includes(filterItems, timeSlot[filterId])) {
            return false;
          }
          return true;
        });
        return allFiltersPassed;
      })
      .sort(timeMomentSort);


      // define first day with times. If the day in this iteration has timeslots and it's earlier than previous set
      // first day with time, update it
      if (filteredTimeSlotsByDate[date].length) {
        const m = moment(date);
        if (m.isSameOrAfter(today, 'day') && (!firstDayWithTimes || m.isBefore(firstDayWithTimes))) {
          firstDayWithTimes = m;
        }
      }
    });
    const newState = { filteredTimeSlotsByDate };
    if (selectFirstDayWithTimes && firstDayWithTimes) {
      newState.date = firstDayWithTimes;
    }
    this.setState(newState);
  }

  selectTimeSlot(timeSlot) {
    console.log('Time slot selected', timeSlot);
    // start fetching unit info if it's not fetched already
    if (!this.props.units[timeSlot.unit].info) {
      this.props.fetchUnitInfo(timeSlot.unit, this.props.userIdentified);
    }
    this.setState({
      selectedTimeSlot: timeSlot
    });
    this.props.setSelectedTimeslotToStore({
      ...timeSlot,
      timeMoment: timeSlot.timeMoment.format('YYYY-MM-DDTHH:mm:ss')
    });
  }

  resetBookingState() {
    console.log('Reset booking...');
    const selectionHandler = this.props.selectionHandler;
    selectionHandler.usePath();
    this.setState({
      useCode: false,
      reset: true
    });
    this.props.bookAgain();
  }


  // set timeslot duration depending whether duration is object or a plane value
  formatTimeSlotDuration(selectedTimeSlot) {
    if (Object.keys(selectedTimeSlot).length === 0 && selectedTimeSlot.constructor === Object) {
      return selectedTimeSlot;
    }
    const type = selectedTimeSlot.type;
    const configDuration = selectedTimeSlot.duration;
    const duration = Object.prototype.hasOwnProperty.call(configDuration, type) ? configDuration[type] : configDuration;
    return Object.assign(selectedTimeSlot, { duration });
  }

  confirmTimeSlot(preFormattedTimeSlot, formValues) {
    const { t, selectionHandler, pathNamespace, defaultLocale } = this.props;
    const defaultLocaleCode = defaultLocale.split('_')[0];
    const timeSlot = this.formatTimeSlotDuration(preFormattedTimeSlot);
    const { reasonText, phone: phoneNumber, email } = formValues;
    const { user, utilizeEmployerInformation, selectedPathType, googleAnalyticsTrackingId, selectedTicketCode } = this.props;
    const { reservationReasonCode } = this.props;
    const selectedPathTitles = selectionHandler.getSelectedOptionIds().map(optionId => t(`${pathNamespace}:pathConfig.${optionId}.title`, { lng: defaultLocaleCode }));
    const phoneNote = phoneNumber ? `Puh: ${phoneNumber}\n` : '';
    let notes = selectedPathTitles.length > 0 ? `${phoneNote}${reasonText}\n${selectedPathTitles.join(' => ')}` : `${phoneNote}${reasonText}`;
    let { company, employer } = this.getUserEmployer();
    const selectedOptions = selectionHandler.getSelectedOptions();
    const finalOption = last(selectedOptions);
    let reservationTicketId;
    let smsConfirmationTextKey = get(finalOption, 'reservation.smsConfirmationTextKey', 'smsConfirmationText');
    let emailConfirmationTextKey = get(finalOption, 'reservation.emailConfirmationTextKey', 'emailConfirmationText');
    let emailReminderTextKey = get(finalOption, 'reservation.emailReminderTextKey', 'emailReminderText');
    let emailLocalisationKeyTitle = get(finalOption, 'reservation.emailLocalisationKeyTitle', 'emailLocalisationKeyTitle');
    let smsReminderTextKey = get(finalOption, 'reservation.smsReminderTextKey', 'smsReminderText');
    const emailFooterText = get(finalOption, 'reservation.emailFooterText', 'emailFooterText');
    let selectionMethod;
    let reasonToPost = reservationReasonCode;
    if (selectionHandler.isByTicket()) {
      selectionMethod = 'TICKET';

      if (selectionHandler.ticket.isMovendosTimeReservationTicket) {
        reservationTicketId = selectionHandler.ticket.id;
        smsConfirmationTextKey = selectionHandler.ticket.smsConfirmationTextKey;
        smsReminderTextKey = selectionHandler.ticket.smsReminderTextKey;
        emailLocalisationKeyTitle = selectionHandler.ticket.emailLocalisationKeyTitle;
        emailReminderTextKey = selectionHandler.ticket.emailReminderTextKey;
        reasonToPost = selectionHandler.ticket.ehrReservationReason;
        notes = `${selectionHandler.ticket.ehrReservationText}\n${notes}`;
        if (selectionHandler.ticket.orgIdForDedicated) {
          employer = undefined;
          company = selectionHandler.ticket.orgIdForDedicated;
        }
      } else {
        const ticketConfirmationKey = `ticket.smsConfirmationTexts.${selectionHandler.ticket.timeType.replace('.', '*')}`;
        const ticketReminderKey = `ticket.smsReminderTexts.${selectionHandler.ticket.timeType.replace('.', '*')}`;
        smsConfirmationTextKey = t(ticketConfirmationKey) === ticketConfirmationKey ? smsConfirmationTextKey : ticketConfirmationKey;
        smsReminderTextKey = t(ticketReminderKey) === ticketReminderKey ? smsReminderTextKey : ticketReminderKey;
        emailLocalisationKeyTitle = t(ticketConfirmationKey) === ticketConfirmationKey ? emailLocalisationKeyTitle : ticketConfirmationKey;
        emailConfirmationTextKey = t(ticketConfirmationKey) === ticketConfirmationKey ? emailConfirmationTextKey : ticketConfirmationKey;
        emailReminderTextKey = t(ticketReminderKey) === ticketReminderKey ? emailReminderTextKey : ticketReminderKey;
      }
    } else if (selectionHandler.isUsingCode()) {
      selectionMethod = 'CODE';
      const codeConfirmationKey = `code.smsConfirmationTexts.${selectionHandler.code.replace('.', '*')}`;
      const codeReminderKey = `code.smsReminderTexts.${selectionHandler.code.replace('.', '*')}`;
      smsConfirmationTextKey = t(codeConfirmationKey) === codeConfirmationKey ? smsConfirmationTextKey : codeConfirmationKey;
      smsReminderTextKey = t(codeReminderKey) === codeReminderKey ? smsReminderTextKey : codeReminderKey;
      emailLocalisationKeyTitle = t(codeConfirmationKey) === codeConfirmationKey ? emailLocalisationKeyTitle : codeConfirmationKey;
      emailConfirmationTextKey = t(codeConfirmationKey) === codeConfirmationKey ? emailConfirmationTextKey : codeConfirmationKey;
      emailReminderTextKey = t(codeReminderKey) === codeReminderKey ? emailReminderTextKey : codeReminderKey;
    } else if (selectionHandler.isUsingPath()) {
      selectionMethod = 'SYMPTOM';
      if (finalOption.reservation.reservationReason) {
        this.props.setReservationReasonCode(finalOption.reservation.reservationReason);
        reasonToPost = finalOption.reservation.reservationReason;
      }
    } else {
      selectionMethod = null;
    }
    // get the language
    const language = i18n.language;
    // construct confirmation text with relevant info

    if (this.isUserSotuTemporary()) {
      const smsConfirmationTextWithTmpSotuKey = `${smsConfirmationTextKey}_userWithTmpSOTU`;
      const emailLocalisationKeyTitleWithTmpSotuKey = `${emailLocalisationKeyTitle}_userWithTmpSOTU`;
      const smsReminderTextWithTmpSotuKey = `${smsReminderTextKey}_userWithTmpSOTU`;
      const emailReminderTextWithTmpSotuKey = `${emailReminderTextKey}_userWithTmpSOTU`;
      const emailConfirmationTextKeyWithSotuKey = `${emailConfirmationTextKey}_userWithTmpSOTU`;
      
      // if localization key for temporary SOTU cases exist, use those
      if (t(smsConfirmationTextWithTmpSotuKey) !== smsConfirmationTextWithTmpSotuKey) {
        smsConfirmationTextKey = smsConfirmationTextWithTmpSotuKey;
        emailConfirmationTextKey = emailConfirmationTextKeyWithSotuKey;
        emailLocalisationKeyTitle = emailLocalisationKeyTitleWithTmpSotuKey;
      }
      if (t(smsReminderTextWithTmpSotuKey) !== smsReminderTextWithTmpSotuKey) {
        smsReminderTextKey = smsReminderTextWithTmpSotuKey;
      }
      if (t(emailReminderTextWithTmpSotuKey) !== emailReminderTextWithTmpSotuKey) {
        emailReminderTextKey = emailReminderTextWithTmpSotuKey;
      }
    }
    const confirmationTextParameters = {
      time: timeSlot.timeMoment.locale(language).format('lll'),
      date: timeSlot.timeMoment.locale(language).format('LL'),
      unitAddress: this.props.units[timeSlot.unit].address,
      unitCity: this.props.units[timeSlot.unit].city,
      reservationCode: '{{reservationCode}}',
      resourceName: this.props.resources[timeSlot.resource].name
    };
    // Note: react-i18next insists on escaping HTML, need to unescape it back
    const smsText = htmlDecode(t(smsConfirmationTextKey, confirmationTextParameters));
    const emailConfirmationSubject = htmlDecode(t(`${emailLocalisationKeyTitle}`));
    const emailConfirmationBody = htmlDecode(t(emailConfirmationTextKey, confirmationTextParameters));
    const footer = htmlDecode(t(`${emailFooterText}`));
    console.log('Storing reservation', timeSlot, formValues);
    // post reservation to backend with email template and SMS text
    this.props.storeReservation(timeSlot, Object.assign({
      client: `/clients/${user.ehrId}`,
      unit: timeSlot.unit,
      unitChangedToLegalUnit: timeSlot.unitChangedToLegalUnit,
      resource: timeSlot.resource,
      start: timeSlot.timeMoment.format('YYYY-MM-DD[T]HH:mm:ss'),
      duration: timeSlot.duration,
      notes,
      selectedPathString: selectedPathTitles.join(' => '),
      selectionMethod,
      phoneNumber,
      smsText,
      emailFooterText: footer,
      email,
      emailReminderTextKey,
      emailConfirmationTextKey,
      emailConfirmationBody,
      emailConfirmationSubject,
      smsReminderTextKey,
      language,
      selectedPathType,
      googleAnalyticsTrackingId,
      rootSelection: pathNamespace,
      reservationReasonCode: reasonToPost,
      reservationTicketId
    },
      utilizeEmployerInformation ? { employer } : { },
      utilizeEmployerInformation ? { company } : { },
      selectedTicketCode !== '' ? { code: selectedTicketCode } : { }), selectedOptions);
  }

  cancelConfirm() {
    this.setState({
      selectedTimeSlot: this.initialState.selectedTimeSlot
    });
  }

  // open link in a new browser window
  openLink(url) {
    const win = window.open(url, '_blank');
    win.focus();
  }

  render() {
//    console.log('Booking.render start!');
    const { errorOccurred, errors, userIdentified, canAnonymousFetchTimes, selectedOptionIds, additionalDiscussionChecked,
      prepareUserRegistration, pathNamespace, reservationByCodeEnabled, pathReservationByCodeEnabled, utilizeEmployerInformation,
      selectionHandler, selectedPathType, pathBasedBooking, viaSso, selectedTicket, hasSelectedTicket, selectedTicketCode, configurationLoaded, loginPolicyType, creationIncomplete, t } = this.props;
    const isReservationByTicket = selectedPathType === pathTypes.BY_TICKET;
    const isReservationHistory = selectedPathType === pathTypes.HISTORY;
    if (!userIdentified && !canAnonymousFetchTimes) {
      // We can return null here if we want users to identify before making any selections.
    }

    // show modal in case of error instead of content
    if (errorOccurred) {
      // Object.keys(errors).map(i => errors[i]).reduce((acc, i) => acc + i)
      const errorFromServer = Object.keys(errors).map(i => errors[i]).reduce((acc, i) => acc + i);
      return (
        <Modal
          className="error generic-error"
          show
          backdrop="static"
          keyboard={false}
        >
          <Button
            bsStyle="link"
            className="close-link basic-action-link"
            onClick={this.onCloseErrorModal}
          >
            <AppIcon iconName="CLOSE" containerClass="close-icon" />
          </Button>
          <ErrorMessage isVisible>
            <strong>{errorFromServer.indexOf('EHR Timeout') > -1 ? t('ehrTimeoutErrorMessage') : t('genericErrorMessage')}</strong>
          </ErrorMessage>
        </Modal>
      );
    }

    selectionHandler.setSelectedOptionIds(selectedOptionIds);

    /**
     * Create code form, reservations history and ticket booking component in case those are enabled and user can see them
     */
    const reservationByCode = (
      <div>
        { reservationByCodeEnabled && pathReservationByCodeEnabled ? (<CodeForm onToggle={this.toggleUseCode} onSubmit={this.requestTimeSlotsUsingCode} />) : null }
      </div>
    );

    const reservationHistory = isReservationHistory && userIdentified && viaSso ? <History /> : null;
    const reservationByTicket = isReservationByTicket && userIdentified ? <ByTicket reservationByCode={reservationByCode} /> : null;

    const bookingPhaseSymptoms = [];
    let requestTimeSlots;
    let identificationSection;
    let bookingPhaseInfoBox;
    let bookingPhaseSelectTime;

    let readyToRequestTimeSlots = false;

    if (selectionHandler.isUsingCode()) {
      readyToRequestTimeSlots = true;
    } else { // Using path selection.
      const levelCount = selectionHandler.getSelectedOptionIds().length;
      let level = 0;
      // render symptoms options for every available level
      while (level <= levelCount) {
        level += 1;
        const nextOptions = selectionHandler.getOptionsForLevel(level);
        if (nextOptions.length > 0) {
          bookingPhaseSymptoms.push(
            <SymptomLevel key={`booking-phase-symptoms-${level}`} title={selectionHandler.getPromptForLevel(level)} text={selectionHandler.getPromptTextForLevel(level)} level={level} >
              <OptionGroup
                onSelect={this.select}
                options={nextOptions}
                selected={selectionHandler.getSelectedOptionIdOnLevel(level)}
                prompt={level > 1 ? selectionHandler.getPromptForLevel(level) : ''}
                level={level}
                info={selectionHandler.getInfoForLevel(level)}
                key={`option-group-${level}`}
                namespace={pathNamespace}
              />
            </SymptomLevel>
          );
        } else {
          console.log(`no options for level -- ${level}`);
        }
        this.state.targetLevel = level > 1 ? level - 1 : 1;
      }

      const finalLevelReached = selectionHandler.isFinalLevelReached();
      if (finalLevelReached) {
        const finalOption = selectionHandler.getLastSelectedOption();
        const finalOptionInfo = selectionHandler.getInfoForLevel(level);
        // if final level has additional information, show info message with it
        if (finalOptionInfo) {
          bookingPhaseInfoBox = (
            <InfoBox content={finalOptionInfo} />
          );
        }
        // if user has selected all levels of symptoms and can select a timeslot
        if (finalOption.reservation) {
          console.log(JSON.stringify(finalOption.reservation));
          const showModifyTimeSlotParamsButton = letUserModifyTimeSlotParams &&
            (!this.state.modifyTimeSlotParamsActivated || this.props.timeSlotsRequested);
          requestTimeSlots = (
            <div id="request-time-slots">
              { showAdditionalDiscussionCheckbox &&
              <AdditionalDiscussionCheckbox
                checked={additionalDiscussionChecked}
                onChange={this.additionalDiscussionValueChanged}
              />
              }
              <div className="request-time-slots-info text-center">
                { this.getSentenceForTimeSlotParams(this.state.modifyTimeSlotParamsActivated
                  || this.getCurrentTimeSlotParams().options) }
                { showModifyTimeSlotParamsButton &&
                <Button
                  className="activate-time-slot-params-btn center-block"
                  onClick={this.activateModifyTimeSlotParams}
                >
                  {t('activateTimeSlotParamsButton')}
                </Button>
                }
              </div>
              <p className="text-center">{t('requestTimeSlotsAdditionalInfo')}</p>
              <Button
                className="action-btn center-block"
                onClick={this.requestTimeSlotsHandler}
              >
                {t('show_time_slots_button')}
              </Button>
            </div>
          );
          readyToRequestTimeSlots = true;
        }
        // if final option is to go to external service
        if (finalOption.external) {
          const linkButtonText = selectionHandler.getLocalizationForLevel(level, 'linkButtonText');
          requestTimeSlots = (
            <div id="request-time-slots">
              <Button className="action-btn center-block" onClick={() => this.openLink(finalOption.external)} >
                {t(linkButtonText)}
              </Button>
            </div>
          );
        }
      }
    }

    if (readyToRequestTimeSlots) {
      // if user is not logged in and path doesn't allow ananymous users to fetch times, prompt authentication
      if (!userIdentified && this.state.userClickedRequestTimeSlots && !canAnonymousFetchTimes) {
        identificationSection = this.getLoginForm(t);
      }

      if (userIdentified || canAnonymousFetchTimes) {
        // prepare timeslots and calendar views
        if (!this.props.requestingTimeSlots && this.props.timeSlotsRequested) {
          const timeSlotsForDay = this.getTimeSlotsForSelectedDay() || [];
          console.log('Rendering time slots...', timeSlotsForDay, this.state);
          const onFocusChange = (focused) => {
            if (focused === this.state.showMobileDatePicker) {
              this.setState({ showMobileDatePicker: focused });
            }
          };
          const onActiveStartDateChangeHandler = ({ activeStartDate }) => {
            const momentDate = moment(activeStartDate);
            this.requestTimeSlotsHandler({ month: momentDate });
            this.setState({
              showMobileDatePicker: false,
            });
          };
          const nextMonthClickHandler = () => {
            console.log('Requesting time slots for next month', this.state.date);
            const month = this.state.date.clone().add(1, 'months');
            this.requestTimeSlotsHandler({ month });
          };
          let responsibleSpecialistsElement;
          const responsibleSpecialists = this.getCurrentResponsibleResources();
          // build a string with responsible specialist(s) name(s)
          if (responsibleSpecialists.length) {
            const responsibleSpecialistsNames = map(responsibleSpecialists, r => r.name);
            let namesText;
            if (responsibleSpecialistsNames.length === 1) {
              namesText = responsibleSpecialistsNames[0];
            } else {
              const allNamesButLast = responsibleSpecialistsNames.slice(0, -1).join(', ');
              const lastName = last(responsibleSpecialistsNames);
              namesText = `${allNamesButLast} ${t('and')} ${lastName}`;
            }

            const selectedLastLevel = this.getSelection();
            const pathSpecificRespKey = selectedLastLevel && selectedLastLevel.id ? `${pathNamespace}:pathConfig.${selectedLastLevel.id}.responsibleResourcesInfo` : '';
            const responsibleTextKey = pathSpecificRespKey !== '' && i18n.exists(pathSpecificRespKey) ? pathSpecificRespKey : 'responsibleResourcesInfo';
            const responsibleSpecialistsText = t(responsibleTextKey, {
              count: responsibleSpecialistsNames.length,
              names: namesText
            });
            console.log('Translating names', { namesText, responsibleSpecialistsText });
            responsibleSpecialistsElement = null;
            // if employer info is utilized, create a button to show timeslots for responsible specialists
            if (utilizeEmployerInformation) {
              responsibleSpecialistsElement = (
                <p className="responsible-specialists-text">
                  <AppIcon iconName="STAR" containerClass="resp-image" />
                  <InnerHtmlContent content={responsibleSpecialistsText} />
                  {' '}
                  <Button
                    bsStyle="link"
                    className="basic-action-link action-link-among-text"
                    onClick={(e) => { this.populateResourceFilter(this.state.showingTimesForCareTeam ? [] : responsibleSpecialists) }}
                  >
                    {t(this.state.showingTimesForCareTeam ? 'showTimesForallResources' : 'showTimesForResponsibleResources')}
                  </Button>
                </p>
              );
            }
          }

          // component for units filter and specialists filter
          const makeMultiSelectFilter = filterId => (
            <MultiSelectButton
              id={filterId}
              label={t(`filters.${filterId}`)}
              className={`${filterId}-filter-group`}
              items={this.filtersConfig[filterId].items}
              activeItems={this.getSelectedFilters(filterId)}
              onSelect={this.updateFilters}
            />
          );
          const makeStartTimeFilter = () => (
            <SingleSelectButton
              id="startTime"
              label={t('filters.startTime')}
              className="start-time-group"
              items={this.startTimeItems}
              activeItem={this.state.startTimeFilter}
              onSelect={this.updateStartTimeFilter}
            />
          );
          bookingPhaseSelectTime = (
            <BookingPhase id="booking-phase-select-time" title={t('sectionTitles.selectTime')}>
              <Grid fluid>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className="time-slot-filters-col">
                    <div className="time-slot-filters text-center">
                      <div>
                        {makeMultiSelectFilter('unit')}
                        {makeMultiSelectFilter('resource')}
                      </div>
                      <div>
                        { /* craeate a button to show calendar for small displays */ }
                        <FormGroup className="mobile-calendar-group">
                          <ControlLabel>{t('filters.date')}</ControlLabel>
                          <Button
                            className="show-mobile-calendar-btn"
                            onClick={() => { this.setState({ showMobileDatePicker: !this.state.showMobileDatePicker }) }}
                          >
                            { this.state.date.format('l') }
                            {' '}
                            <AppIcon iconName="CALENDAR" containerClass="calendar-icon" />
                          </Button>
                        </FormGroup>
                        {makeStartTimeFilter()}
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className="text-center responsible-specialists-container">
                    {responsibleSpecialistsElement}
                  </Col>
                </Row>
                <Row>
                  <Col md={5} lg={5} className="date-input">
                    {(!this.state.isMobile || this.state.showMobileDatePicker) && (
                      <div
                        tabIndex={0}
                        onFocus={() => onFocusChange(true)}
                        onBlur={() => onFocusChange(false)}
                      >
                        <Calendar
                          id="date-input"
                          value={new Date(this.state.date)}
                          navigationAriaLabel={t('common:ariaLabels.navigationAriaLabel')}
                          nextAriaLabel={t('common:ariaLabels.nextAriaLabel')}
                          prevAriaLabel={t('common:ariaLabels.prevAriaLabel')}
                          prev2Label={null}
                          next2Label={null}
                          locale={i18n.language}
                          tileDisabled={({ date, view }) => view === 'month' && !this.hasFreeTimesForDay(date)}
                          onClickDay={this.selectDate}
                          onActiveStartDateChange={({ activeStartDate, view }) => view === 'month' && onActiveStartDateChangeHandler({ activeStartDate })}
                        />
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={7} lg={7} className="time-slots-col">
                    { isEmpty(timeSlotsForDay) ? (
                      <ErrorMessage isVisible>
                        <strong>{t('timeSlotsNotFoundErrorTitle')}</strong>
                        <p>{t('timeSlotsNotFoundErrorMessage')}</p>
                        <Button
                          className="action-btn-small next-month-btn"
                          onClick={(e) => { nextMonthClickHandler() }}
                        >
                          {t('timeSlotsNotFoundNextMonthLink')}
                        </Button>
                      </ErrorMessage>
                    ) : (
                      <TimeSlots
                        timeSlots={timeSlotsForDay}
                        units={this.props.units}
                        selectedTimeSlot={this.formatTimeSlotDuration(this.state.selectedTimeSlot)}
                        onClick={this.selectTimeSlot}
                      />
                    )}
                  </Col>
                </Row>
              </Grid>
            </BookingPhase>
          );
        }
      }
    }


    // If we have reached this point and the user is not logged in,
    // then it means that canAnonymousFetchTimes must be true.
    const selectedTimeSlot = !isEmpty(this.state.selectedTimeSlot);
    const showConfirmationDuringRegistration = selectedTimeSlot && (!userIdentified && canAnonymousFetchTimes);
    let identificationAndRegistrationPhase = '';
    // user must either log in, sign up or fill up missing information
    if (showConfirmationDuringRegistration || (selectedTimeSlot && creationIncomplete)) {
      identificationAndRegistrationPhase = (
        <BookingPhase id="booking-phase-identify-late" title={t('lateLoginPhaseTitle')}>
          <Collapse in={!userIdentified || creationIncomplete} unmountOnExit>
            <SimpleBox className="registration">
              <div className="box-header">
                <h1>{(!prepareUserRegistration && !creationIncomplete) ? t('lateLoginBookingPhaseHeading') : t('registrationBookingPhaseHeading')}</h1>
                {!prepareUserRegistration && !creationIncomplete && t('lateLoginBookingPhaseInfo')}
                <Collapse in={!prepareUserRegistration && !creationIncomplete} unmountOnExit>
                  <LoginComponent loginType={loginPolicyType} />
                </Collapse>
                <Collapse in={prepareUserRegistration || creationIncomplete} unmountOnExit>
                  <RegistrationForm />
                </Collapse>
              </div>
            </SimpleBox>
          </Collapse>
        </BookingPhase>
      );
    }

    // The confirmation phase requires the user to be logged in.
    let bookingPhaseConfirm = '';
    const isUsingPath = selectionHandler.isUsingPath() && selectionHandler.getSelectedOptions().length > 0;
    if (selectedTimeSlot && userIdentified && !creationIncomplete) {
      bookingPhaseConfirm = (
        <BookingPhase id="booking-phase-confirm" title={t('sectionTitles.confirmReservation')}>
          <div className="booking-phase-centered-content">
            <Collapse in={isUsingPath} unmountOnExit>
              <SelectionPathInfo path={selectionHandler.getSelectedOptions()} prefix={'pathConfig'} namespace={pathNamespace} />
            </Collapse>
            <Collapse in={userIdentified} unmountOnExit>
              <ConfirmTimeSlotForm
                timeSlot={this.formatTimeSlotDuration(this.state.selectedTimeSlot)}
                ticketCode={this.props.selectedTicketCode}
                onConfirm={this.confirmTimeSlot}
                onCancel={this.cancelConfirm}
                smsConfirmationEnabled={this.props.smsConfirmationEnabled}
                emailConfirmationEnabled={this.props.emailConfirmationEnabled}
                unit={this.props.units[this.state.selectedTimeSlot.unit]}
                optionalReservationText={this.props.optionalReservationText}
              />
            </Collapse>
          </div>
          <hr />
          <UnitInfoContainer unit={this.getUnitData(this.state.selectedTimeSlot.unit)} />
        </BookingPhase>
      );
    }

    const showSelectionPathUsingProps = this.props.reservation && this.props.reservation.selectionPath && this.props.reservation.selectionPath.length > 0;
    let bookingPhaseReservationDone = '';
    // show confirmation message if reservation was done
    if (this.props.reservationDone) {
      let confirmationInfo = null;
      let pathSpecificConfInfo = '';
      const selectedLastLevel = this.getSelection();
      if (selectedLastLevel && selectedLastLevel.id) {
        pathSpecificConfInfo = `${pathNamespace}:pathConfig.${selectedLastLevel.id}.confirmationInfo`;
        confirmationInfo = i18n.exists(pathSpecificConfInfo) ? t(pathSpecificConfInfo) : null;
      }
      bookingPhaseReservationDone = !this.props.reservationDone ? '' : (
        <BookingPhase id="booking-phase-reservation-done" title={t('reservationDone.title')}>
          <div className="booking-phase-centered-content center-block text-center">
            <p className="large-text">{t('reservationDone.info1', { reservationCode: this.props.reservation.data.code })}</p>
            <br />
            <p className="large-text">{this.props.selectedTicketCode ? this.props.selectedTicket.clientNotes : t(`${pathNamespace}:reservationDone.info2`)}</p>
          </div>
          { confirmationInfo &&
          <div>
            <Alert bsStyle="info"><InnerHtmlContent content={confirmationInfo} /></Alert>
          </div>
          }
          <hr />
          { /* show summary of selected options and selected timeslot when reservation is done */ }
          <div className="booking-phase-centered-content reservation-details">
            <Collapse in={showSelectionPathUsingProps && isUsingPath} unmountOnExit>
              <SelectionPathInfo path={this.props.reservation.selectionPath} prefix={'pathConfig'} namespace={pathNamespace} />
            </Collapse>
            <TimeSlotCard
              large
              timeSlot={this.props.reservation.timeSlot}
              unit={this.props.units[this.props.reservation.timeSlot.unit]}
              actionElement={<AppIcon iconName="CHECKMARK" containerClass="booking-done-image" />}
            />
            <div className="reservation-done-action-buttons">
              <Button
                className="booking-done-logout-link center-block"
                onClick={() => { this.props.logout(this.props.viaSso) }}
              >
                {t('logoutButton')}
              </Button>
              <Button
                className="booking-done-reserve-new-time-link center-block"
                onClick={this.resetBookingState}
              >
                {t('reservationDone.bookAgain')}
              </Button>
            </div>
          </div>
          <hr />
          <div className="booking-phase-centered-content">
            <UnitInfo unit={this.getUnitData(this.props.reservation.timeSlot.unit)} />
          </div>
        </BookingPhase>
      );
    }

//    console.log('Booking.render end!');

    return (
      <div className="booking">
        { !this.props.reservationDone && this.props.pathLoaded &&
        // needed to not show path for uesrs in occupational path without employer
        <Collapse in={configurationLoaded}>
          <div>
            { pathBasedBooking &&
              <div>
                <h2 className="test booking-phase-title">{selectionHandler.getTitleForPath()}</h2>
                <hr />
                {reservationByCode}
                {bookingPhaseSymptoms}
              </div>
            }
            {reservationByTicket}
            {reservationHistory}
            {bookingPhaseInfoBox}
            <div id={'request-time-slots-container'}>
              {requestTimeSlots}
            </div>
            <div id={'anchor-scroll-target'} />
            <div id={'booking-phase-select-time-container'}>
              {identificationSection}
              {bookingPhaseSelectTime}
            </div>
            <div id={'booking-phase-confirm-container'}>
              {identificationAndRegistrationPhase}
              {bookingPhaseConfirm}
            </div>
          </div>
        </Collapse>
        }
        {bookingPhaseReservationDone}
      </div>
    );
  }
}

Booking.propTypes = {
  userIdentified: PropTypes.bool.isRequired,
  canAnonymousFetchTimes: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    ehrId: PropTypes.string,
    sotu: PropTypes.string,
    employers: PropTypes.array.isRequired
  }),
  errorOccurred: PropTypes.bool,
  errors: PropTypes.shape({}),
  selectedEmployer: PropTypes.number.isRequired,
  hasDepartment: PropTypes.bool.isRequired,
  selectedDepartment: PropTypes.number.isRequired,
  selectedOptionIds: PropTypes.array.isRequired,
  selectedOptionsChanged: PropTypes.func.isRequired,
  fetchUnitInfo: PropTypes.func.isRequired,
  additionalDiscussionChanged: PropTypes.func.isRequired,
  additionalDiscussionChecked: PropTypes.bool,
  requestTimeSlots: PropTypes.func.isRequired,
  requestingTimeSlots: PropTypes.bool,
  timeSlotsRequested: PropTypes.bool,
  smsConfirmationEnabled: PropTypes.bool.isRequired,
  emailConfirmationEnabled: PropTypes.bool.isRequired,
  clearTimeSlots: PropTypes.func.isRequired,
  resources: PropTypes.shape({}),
  groups: PropTypes.shape({}),
  units: PropTypes.shape({}),
  timeSlots: PropTypes.shape({}),
  storeReservation: PropTypes.func.isRequired,
  reservation: PropTypes.shape({
    selectionPath: PropTypes.array,
    timeSlot: PropTypes.shape({
      unit: PropTypes.string.isRequired
    }),
    data: PropTypes.shape({
      code: PropTypes.string.isRequired
    })
  }),
  reservationDone: PropTypes.bool,
  reservationByCodeEnabled: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  bookAgain: PropTypes.func.isRequired,
  prepareUserRegistration: PropTypes.bool.isRequired,
  pathNamespace: PropTypes.string.isRequired,
  currentlyIdentifying: PropTypes.bool.isRequired,
  currentlyRegistering: PropTypes.bool.isRequired,
  storingReservation: PropTypes.bool.isRequired,
  pathReservationByCodeEnabled: PropTypes.bool.isRequired,
  utilizeEmployerInformation: PropTypes.bool.isRequired,
  selectionHandler: PropTypes.object.isRequired,
  pathLoaded: PropTypes.bool.isRequired,
  selectedPathType: PropTypes.string,
  googleAnalyticsTrackingId: PropTypes.string,
  viaSso: PropTypes.bool.isRequired,
  pathBasedBooking: PropTypes.bool.isRequired,
  selectedTicket: PropTypes.object.isRequired,
  hasSelectedTicket: PropTypes.bool.isRequired,
  selectedTicketCode: PropTypes.string.isRequired,
  optionalReservationText: PropTypes.bool.isRequired,
  legalEntity: PropTypes.string.isRequired,
  defaultLocale: PropTypes.string.isRequired,
  reservationReasonCode: PropTypes.number,
  t: PropTypes.func.isRequired,
  setReservationReasonCode: PropTypes.func.isRequired,
  loginPolicyType: PropTypes.string.isRequired,
  configurationLoaded: PropTypes.bool.isRequired,
  restoredState: PropTypes.bool.isRequired,
  setSelectedTimeslotToStore: PropTypes.func.isRequired,
  unsetSelectedTimeslotToStore: PropTypes.func.isRequired,
  selectedStoredTimeSlot: PropTypes.object.isRequired,
  requiresEmployer: PropTypes.bool.isRequired,
  creationIncomplete: PropTypes.bool.isRequired,
  showOwnTeamByDefault: PropTypes.bool.isRequired
};

Booking.defaultProps = {
  canAnonymousFetchTimes: false,
  additionalDiscussionChecked: false,
  errorOccurred: false,
  errors: {},
  requestingTimeSlots: false,
  timeSlotsRequested: false,
  reservation: {},
  reservationDone: false,
  prepareUserRegistration: false,
  currentlyIdentifying: false,
  currentlyRegistering: false,
  storingReservation: false,
  resources: {},
  groups: {},
  units: {},
  user: {},
  timeSlots: {},
  pathNamespace: '',
  pathReservationByCodeEnabled: false,
  utilizeEmployerInformation: false,
  selectionHandler: null,
  pathLoaded: false,
  selectedPathType: '',
  googleAnalyticsTrackingId: '',
  selectedTicket: {},
  selectedTicketCode: '',
  legalEntity: '',
  defaultLocale: '',
  reservationReasonCode: null,
  showOwnTeamByDefault: false
};

export default translate(props => ['booking', props.pathNamespace], { wait: true })(Booking);



// WEBPACK FOOTER //
// ./src/containers/Booking/Booking.jsx